type Position = {
  display_name?: string;
};

type Specialty = {
  id?: string | number;
  label?: string;
  positions?: Position[];
};

export const formatSpecialtyWithPositions = (specialty?: Specialty) => {
  const label = specialty?.label ?? '';
  const position = specialty?.positions
    ?.map((p) => p.display_name)
    .filter(Boolean)
    .join(', ');

  if (!position) {
    return label;
  }

  return `${position}: ${label}`;
};
